import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const migratedDialog = (props) => {
  const {
    migrated, handleClose,
  } = props;
  return (
    <Dialog
      open={migrated}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">
      Account Migrated
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
        Your account has been migrated to SSO. Please log in again to your SSO account.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" style={{ color: '#fff' }} onClick={handleClose} color="primary">
              Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default migratedDialog;
